import PageSpinner from './PageSpinner';

export default PageSpinner;
